export default __webpack_public_path__ + "static/media/DNo.26-5.ed19d99d.jpg";